import { jsxs as V, jsx as o } from "react/jsx-runtime";
import { Colors as y } from "../../../styles/colors/index.js";
import { Theme as A } from "../../../styles/themes/index.js";
import { DealVoteAction as u, VoteKind as m } from "../../../types/Deal/index.js";
import { DealTemperatureLevel as n, DealVotedContainer as H, RemoveVoteIcon as h, VotedIcon as B, DealVoteTemperature as D, DealVoteButtonContainer as L, DealVoteColdDown as _, SnowIcon as g, DealVoteWarmUp as x, FlameIcon as F, DISABLE_HOVER_ICE as I, DISABLE_HOVER_HOT as K } from "./style.js";
import { useTranslation as $ } from "../../../hooks/useTranslation/index.js";
import { Xmark as j, FireFlameCurved as T, Snowflake as b } from "@pelando/fontawesome/icons";
const O = (e) => e < 0 ? n.COLD : e < 300 ? n.NORMAL : e < 1e3 ? n.HOT : n.VERY_HOT;
function q({
  id: e,
  temperature: a,
  voteInfo: l,
  inactive: i,
  dispatch: c,
  className: s,
  disabled: r,
  isOnboardingCard: S,
  disableDecrease: v,
  disableIncrease: p
}) {
  const { t } = $("common"), C = `${a}º`, E = `rgb(${y.Gray})`, f = `rgb(${y.Blue})`, k = `rgb(${A.colors.Brand})`, d = { cursor: r ? "default" : "pointer" }, R = p ? { [I]: "transparent", cursor: "default" } : {}, w = v ? { [K]: "transparent", cursor: "default" } : {};
  return l != null && l.voted ? /* @__PURE__ */ V(
    H,
    {
      title: t("deal-vote-button-undo-title"),
      kind: l.kind,
      className: s,
      onClick: () => c({
        type: u.REMOVE_VOTE,
        payload: { id: e, voteKind: l.kind }
      }),
      disabled: r,
      style: d,
      children: [
        /* @__PURE__ */ o(
          h,
          {
            icon: j,
            "aria-label": t("deal-vote-button-remove-vote-title")
          }
        ),
        /* @__PURE__ */ o(
          B,
          {
            "aria-label": t("deal-vote-button-remove-vote-title"),
            icon: l.kind === m.INCREASE ? T : b
          }
        ),
        /* @__PURE__ */ o(D, { level: O(a), children: C })
      ]
    }
  ) : /* @__PURE__ */ V(
    L,
    {
      className: s,
      inactive: i,
      hasAnimation: S,
      children: [
        /* @__PURE__ */ o(
          _,
          {
            title: t("deal-vote-button-cold-down-title"),
            onClick: () => c({
              type: u.VOTE,
              payload: { id: e, voteKind: m.DECREASE }
            }),
            disabled: p || r,
            style: { ...d, ...R },
            children: /* @__PURE__ */ o(
              g,
              {
                icon: b,
                "aria-label": t("deal-vote-button-cold-down-title"),
                style: {
                  color: i ? E : f
                }
              }
            )
          }
        ),
        /* @__PURE__ */ o(D, { level: O(a), children: C }),
        /* @__PURE__ */ o(
          x,
          {
            title: t("deal-vote-button-warm-up-title"),
            onClick: () => c({
              type: u.VOTE,
              payload: { id: e, voteKind: m.INCREASE }
            }),
            disabled: v || r,
            style: { ...d, ...w },
            children: /* @__PURE__ */ o(
              F,
              {
                icon: T,
                "aria-label": t("deal-vote-button-warm-up-title"),
                style: {
                  color: i ? E : k
                }
              }
            )
          }
        )
      ]
    }
  );
}
export {
  q as DealVoteButton,
  O as getTemperatureLevelByValue
};
